import $ from 'jquery';
import React from 'react';
import Chart from "react-google-charts";
import {UserToken,getUserObjData} from '../function_lib/userToken';
import {CallMapMethod, GetDateDifferecec,CallMapMethod_CBack} from '../function_lib/common_lib';
// import {GlobalContext} from '../context';
import {GbSetGetPartyInfo,GbSetGetItemInfo} from '../cGlobal/cls_global';

import Header from '../user_pages/header';
import Footer from '../user_pages/footer';

import LogoImg from '../assets/images/logo.png';
import defaultPic from '../assets/images/9.png';

//import Upcoming_Events from '../components/upcoming_events';
//import Emp_On_Leave from '../components/emp_on_leave';
//import Broadcast from '../components/broadcast';
//import Mobile_Widgets from '../components/mobile_widgets';
import {Custom_Alert,Alert_Content} from '../components/custom_alert';

import {Comp_Quick_Activity,Comp_Officers_Quick_Acitvity} from '../lms_component/comp_quick_activity';
import {Comp_User_Activity} from '../lms_component/comp_user_activity';
import {Comp_Member_Quick_Activity} from '../lms_component/comp_member_quick_access';
import {Comp_Member_Activity} from '../lms_component/comp_member_activity';
import {Comp_Version_Details} from '../lms_component/comp_version_details';

import {Comp_CRB_Introduction} from '../lms_component/comp_crb_introduction';
import {Comp_CRB_Roles_Resp} from '../lms_component/comp_crb_roles_resp';
import {Comp_CRB_Educational_Rec} from '../lms_component/comp_crb_educational_rec';


import './dashboard_new.css';

//import UserManual from '../assets/Operational_Instructions.pdf';

let loginUser="";
let userObject="";
let companyName="";
let userType="";
let clsDashboardNew;

let _chkOrderCall=false;
let _chkAnalyticsCall=false;
let _chkCmsCall=false;
class Comp_Dashboard extends React.Component{
    forceUpdateHandler(){
        this.forceUpdate();
      };
    constructor(props){
        super(props);
        //alert("i m in dashboard");
        //alert(JSON.stringify(this.props));
        clsDashboardNew=this;
        this.state={stGbPartyInfo:[],stDashboardData:{},stLiceseInfo:{}};
        
        //this.state={no_entities:0,no_clients:0,no_vendors:0}
        this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
        userType="0";
        
        if(localStorage.getItem("userData")!=null){
          userObject= getUserObjData();
          //alert(JSON.stringify(userObject));
          loginUser=userObject[0].first_name;
          companyName=userObject[0].first_name;
      }

     
      //alert(ret);
     
    }

    
     
    getLicenseInfo(){
      var map=[];
      map.push({name:"curl_type",value:"getLicense"});
      map.push({name:"res_func",value:"callBackrrr"});
      map.push({name:"local_token",value:userObject[0].id});
      //map.push({name:"acc_inf_id",value:userObject[0].app_user_id});
      
      map["res_func"]="callBackrrr";
      map["curl_type"]="getLicense";
      CallMapMethod_CBack(clsDashboardNew,map,function(data,msg){
        //alert(data);
          if(data==="001" && msg==="True"){
            clsDashboardNew.setState({stLiceseInfo:{"data":data,"msg":msg}},()=>{
              clsDashboardNew.getDashboardData();
            });
            
          }else if(data==="autherror"){
            clsDashboardNew.setState({stLiceseInfo:{"data":data,"msg":msg}});
            clsDashboardNew.getDashboardData();
            //alert(data+"=="+msg);
          }
            
            else{
              //alert("check");
              Custom_Alert("Not Valid",msg,true,"../");
              localStorage.clear();
            }
      });
}

getDashboardData(){
  let map=[];
  map.push({name:"curl_type",value:"getDashboardAnalytics"});
  map.push({name:"res_func",value:"callBackrrr"});
  map.push({name:"local_token",value:userObject[0].id});
  
  //map.push({name:"acc_inf_id",value:userObject[0].app_user_id});
  
  map["res_func"]="callBackrrr";
  map["curl_type"]="getDashboardAnalytics";
  CallMapMethod_CBack(clsDashboardNew,map,function(data,msg){
     //alert(data);
    if(data!=="0" && data!=="autherror"){
      let lsData=JSON.parse(data);
      //alert(lsData["category_counts"]);
      clsDashboardNew.setState({stDashboardData:lsData});
    }else{

    }
  });

}

      componentDidMount(){

        this.getLicenseInfo();
       //this.getDashboardData();
        //this.getMasters();
        $("#divEmployee").show();
        //this.forceUpdateHandler();
      }
   //Get no of Entities/Client/Vendos
     
   
     

    render(){
      
        return(<div className="wrapper">
            <Header/>
            {/* <GbSetGetPartyInfo getSet="set" lsPartyInfo={this.state.stGbPartyInfo}/> */}
            {/* <Mobile_Widgets/> */}
            <div class="content" style={{"min-height":"150px"}}>
            <div class="container-fluid mt-4">
{/* student case instructions */}



{/* <a href={"../cadet/cadet_record_book"}><h5></h5></a> */}

                  {/* component init  */}
                  {/* member quick access */}

                  

                  {typeof this.state.stDashboardData.cadet!=="undefined"?<>
                  <Comp_Member_Quick_Activity dashboardData={this.state.stDashboardData} userObject={userObject}/>
                  <Comp_Member_Activity/>
                  </>
                :''  
                
                }

                {/* for Other Officers */}
                {userObject[0].type.toString()==="11" || userObject[0].type.toString()==="12" || userObject[0].type.toString()==="14"?
                <>
                <Comp_Officers_Quick_Acitvity/>
                {/* <Comp_User_Activity/> */}

                </>:''
                
                }
                  


                  {/* for other users not cadetes and can be STO,CTOs */}

                  {typeof this.state.stDashboardData.admin!=="undefined" && (userObject[0].type.toString()==="1" || userObject[0].type.toString()==="3")?<>
                    {/* quick activivity */}

                    <Comp_Quick_Activity/>
                    {/* end of quick acitivity */}

                    {/* User Activity */}
                    <Comp_User_Activity/>
                    {/* end of user Activity */}
                  </>:''}

                  
                  {typeof this.state.stLiceseInfo.data!=="001"?<><Comp_Version_Details versionInfo={this.state.stLiceseInfo}/></>:''}
                

                  {/* end of component init */}
             
</div>
      </div> 
      <Alert_Content/>
        <Footer/>
        <Comp_CRB_Introduction/>
        <Comp_CRB_Roles_Resp/>
        <Comp_CRB_Educational_Rec/>
      </div>)
    }
}
export default Comp_Dashboard